export const QuoteProductID = {
    BANNER_OPTERM_PRODUCT_ID: 1000, 
    PACIFIC_LIFE_PROMISE_TERM_PRODUCT_ID: 1005, 
    PENN_OPTERM_PRODUCT_ID: 1016, 
    AMERICO_TERM_PRODUCT_ID: 1017,
    LGA_PRODUCT_ID: 1033,
    SYMETRA_SWIFT_TERM_PRODUCT_ID: 1039, 
    PRUDENTIAL_SIMPLY_TERM_PRODUCT_ID: 1042,
}